import { IEvent } from "~app/common/services/cqs/event.service";
import { IWebInstallningDTO } from "../../models/webInstallning-models";

export class WebinstallningOnLoginEvent implements IEvent {
    webinstallningar: IWebInstallningDTO[];
    $type: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "WebinstallningOnLoginEvent";
    constructor() {
        this.$type = WebinstallningOnLoginEvent.$type;
    }
}
